<div class="language-switcher">
    <div class="dropdown" (click)="toggleDropdown()" [class.open]="isDropdownOpen">
        <!-- Dropdown Button -->
        <div class="dropdown-toggle">
            <img [src]="getFlag(selectedLanguage)" alt="Flag" class="flag-icon" />
            <span>{{ getLanguageLabel(selectedLanguage) }}</span>
            <span class="arrow-down">▼</span>
        </div>

        <!-- Dropdown Options -->
        <ul class="dropdown-menu" *ngIf="isDropdownOpen">
            <li *ngFor="let lang of availableLanguages" (click)="selectLanguage(lang.code, $event)">
                <img [src]="getFlag(lang.code)" alt="Flag" class="flag-icon" />
                <span>{{ lang.label }}</span>
            </li>
        </ul>
    </div>
</div>
